<template>
  <div class="page">
    <el-card shadow="never">
      <div slot="header" class="card-header">
        <span>被封禁用户</span>
        <el-button type="primary" size="small" @click="openBanDialog">添加封禁</el-button>
      </div>
      <el-table v-loading="loading" :data="list" border stripe>
        <el-table-column prop="id" label="ID" width="70" />
        <el-table-column prop="userId" label="用户ID" width="100" />
        <el-table-column prop="reason" label="原因" min-width="200" show-overflow-tooltip />
        <el-table-column prop="createdAt" label="封禁时间" min-width="160" />
        <el-table-column label="操作" width="100" fixed="right">
          <template slot-scope="{ row }">
            <el-button type="text" size="small" @click="handleUnban(row)">解封</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="pagination"
        background
        layout="total, prev, pager, next"
        :current-page.sync="page"
        :page-size="pageSize"
        :total="total"
        @current-change="handlePageChange"
      />
    </el-card>

    <el-dialog title="封禁用户" :visible.sync="banVisible" width="420px">
      <el-form ref="banForm" :model="banForm" :rules="banRules" label-width="80px">
        <el-form-item label="用户ID" prop="userId">
          <el-input v-model.number="banForm.userId" placeholder="请输入用户ID" />
        </el-form-item>
        <el-form-item label="原因">
          <el-input v-model="banForm.reason" type="textarea" :rows="3" placeholder="封禁原因" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="banVisible = false">取消</el-button>
        <el-button type="primary" :loading="submitting" @click="submitBan">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getBannedUsers, banCommentUser, unbanUser } from '@/api/admin'
import listPage from '@/mixins/listPage'

export default {
  name: 'CommentsBanUsers',
  mixins: [listPage],
  data() {
    return {
      banVisible: false,
      submitting: false,
      banForm: { userId: null, reason: '' },
      banRules: {
        userId: [{ required: true, message: '请输入用户ID', trigger: 'blur' }]
      }
    }
  },
  created() {
    this.loadList()
  },
  methods: {
    fetchList(params) {
      return getBannedUsers(params)
    },
    openBanDialog() {
      this.banForm = { userId: null, reason: '' }
      this.banVisible = true
    },
    submitBan() {
      this.$refs.banForm.validate(async valid => {
        if (!valid) return
        this.submitting = true
        try {
          await banCommentUser(this.banForm)
          this.$message.success('封禁成功')
          this.banVisible = false
          this.loadList()
        } catch (e) {
        } finally {
          this.submitting = false
        }
      })
    },
    handleUnban(row) {
      this.$confirm('确定解封该用户？', '提示', { type: 'warning' }).then(async () => {
        try {
          await unbanUser(row.userId)
          this.$message.success('已解封')
          this.loadList()
        } catch (e) {
        }
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.pagination {
  margin-top: 16px;
  text-align: right;
}
</style>
